import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatProgressSpinner} from '@angular/material/progress-spinner';
import { MatDialog } from '@angular/material/dialog';
import { AlertifyService } from 'src/app/services/alertify.service';
import { HorarioService } from 'src/app/services/horario.service';
import { horarioLst } from 'src/app/models/horarioLst';
import { DisciplinaService } from 'src/app/services/disciplina.service';
import { CreateEditHorarioComponent } from '../create-edit-horario/create-edit-horario.component';
import { EmpresaService } from 'src/app/services/empresa.service';
import { UsuariosXHorarioComponent } from '../usuarios-xhorario/usuarios-xhorario.component';

@Component({
  selector: 'app-index-horario',
  templateUrl: './index-horario.component.html',
  styleUrls: ['./index-horario.component.scss'],
})
export class IndexHorarioComponent implements OnInit {
  public dataSource: any;
  public displayedColumns: string[];
  public isLoadingResults = false;
  public lstDisciplinas: any;
  public disciplinaSelect: any;
  pageIndex: number = 0;
  pageSize: number = 100;
  length: number;
  searchString: string = '';

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    public horarioSvc: HorarioService,
    public disciplinaSvc: DisciplinaService,
    public dialog: MatDialog,
    private alertify: AlertifyService
  ) {
    let ELEMENT_DATA: horarioLst[] = [];
    this.displayedColumns = [
      'nombre',
      'disciplina',
      'piscina',
      'dias',
      'horaInicio',
      'horaFin',
      'habilitado',
      'usuariosRegistrados',
    ];

    this.dataSource = new MatTableDataSource<horarioLst>(ELEMENT_DATA);
  }
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.getHorarios(0, 100);
    this.disciplinaSvc.getDisciplinasDropdown().subscribe((disLst) => {
      console.log(disLst);
      this.lstDisciplinas = disLst;
    });
  }

  ngOnInit(): void {}

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  getHorarios(page: number, numReg: number) {
    this.isLoadingResults = true;
    this.horarioSvc
      .getHorarios(page, numReg, this.searchString, this.disciplinaSelect)
      .subscribe((result) => {
        this.dataSource = new MatTableDataSource<horarioLst>(result[0]);
        this.pageIndex = page;
        this.pageSize = numReg;
        this.length = result[1];
        this.isLoadingResults = false;
        console.log('resultado: ', result);
        //this.displayedColumns = ['id', 'nombre', 'email', 'documento'];
      });
  }

  getServerData(event: PageEvent) {
    console.log('click evento paginator', event);
    this.getHorarios(event.pageIndex, event.pageSize);
  }

  onEnter() {
    console.log('boton enter');
    this.getHorarios(0, 10);
  }

  cambioDiscipinaBuscar() {
    this.getHorarios(this.pageIndex, this.pageSize);
  }

  openDialogCreate(): void {
    let dialogRef = this.dialog.open(CreateEditHorarioComponent, {
      data: null,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log('dialogo cerrado: ');
      console.log(result);
      console.log(result == 'false');
      if (result == 'false') {
        console.log('dialogo cerrado - no actualiza');
      } else {
        console.log('dialogo cerrado - SI actualiza por creacion');
        this.getHorarios(this.pageIndex, this.pageSize);
      }
    });
  }

  verDeportistas(obj: any) {
    console.log(obj);
    this.dialog.open(UsuariosXHorarioComponent, {
      data: obj,
    });
  }

  descargarReporte() {
    this.horarioSvc.downloadFullDeportistasHorario().subscribe((result) => {
      console.log('result: ', result);

      let blob = new Blob([result], { type: 'application/vnd.ms-excel' });

      var downloadURL = window.URL.createObjectURL(result);
      var link = document.createElement('a');
      link.href = downloadURL;
      link.download =  'usuariosXHorarioFull' + '.xlsx';
      link.click();
    });
  }
}
